import React from 'react';
import { DotNotification, FlexTableCol, FlexTableRow } from 'virtues-bootstrap';
import HoverInfo from 'components/HoverInfo/index';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ReactComponent as RedirectIcon } from 'svg/sign-out.svg';
import s from './styles.module.scss';

const PatientListRow = ({
  age,
  withNotification,
  id,
  isClinicianAbility,
  isDoctor,
  name,
  deviceVendor,
  deviceType,
  activationDate,
  report,
  deceasedDate,
  eightTeenMonthFollowup,
}) => {
  return (
    <FlexTableRow className={s.row} to={`/patient/${id}`} component={Link}>
      {isClinicianAbility ? (
        <FlexTableCol className={s.name}>
          {withNotification ? <DotNotification className={s.dot} /> : null}
          <strong>{name}</strong>
          {deceasedDate || eightTeenMonthFollowup === '18 Month Visit: Complete' ? (
            <HoverInfo content={[deceasedDate, eightTeenMonthFollowup]} />
          ) : null}
        </FlexTableCol>
      ) : null}
      <FlexTableCol>{`RPM-CIED-${id}`}</FlexTableCol>
      <FlexTableCol>{age}</FlexTableCol>
      <FlexTableCol>{deviceVendor}</FlexTableCol>
      <FlexTableCol>{deviceType}</FlexTableCol>
      <FlexTableCol>{activationDate}</FlexTableCol>
      {isDoctor ? (
        <FlexTableCol>
          {report ? (
            <Link className={s.reportTitle} to={`/patient/${id}/transmission-report/${report.id}`}>
              <div className={s.report}>
                <RedirectIcon className={s.redirectIcon} />
                <span className={s.reportTitle}>{report.lastUpdated}</span>
              </div>
            </Link>
          ) : (
            <Link to={`/patient/${id}/transmission-report`}>
              <RedirectIcon className={s.redirectIcon} />
            </Link>
          )}
        </FlexTableCol>
      ) : null}
    </FlexTableRow>
  );
};

PatientListRow.propTypes = {
  age: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isClinicianAbility: PropTypes.bool.isRequired,
  isDoctor: PropTypes.bool.isRequired,
  withNotification: PropTypes.bool,
  name: PropTypes.string.isRequired,
  report: PropTypes.shape({
    id: PropTypes.string,
    lastUpdated: PropTypes.string,
  }),
  activationDate: PropTypes.string.isRequired,
  deviceVendor: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  deceasedDate: PropTypes.string,
  eightTeenMonthFollowup: PropTypes.string,
};

PatientListRow.defaultProps = {
  withNotification: false,
  report: null,
  deceasedDate: null,
  eightTeenMonthFollowup: null,
};

export default PatientListRow;
